export default __webpack_public_path__ + "static/media/failed.b96ecb3e.svg";